(ns cms.asset
  (:require 
    [cms.fetch :refer [fetch]]
    [cemerick.url :as url]
    [firebase.functions :as fns]
    [firebase.auth :as auth]
    [clojure.string :as str]
    [promises.core :refer-macros [await->]]))

(def extension->mime
  {"musicxml" "application/vnd.recordare.musicxml+xml"
   "xml"      "application/xml"
   "txt"      "text/plain"
   "csv"      "text/csv"
   "json"     "application/json"
   "ogg"      "audio/ogg"})

(def mime->extension
  (into {} (for [[k v] extension->mime] [v k])))

(def text-extensions 
  #{"xml" "txt" "csv" "json" "musicxml"})

(defn detect-encoding
  "Reads the first few bytes of a File to detect BOM encoding. Defaults to UTF-8."
  [^js file]
  (let [slice   (.slice file 0 4)
        reader  (js/FileReader.)
        promise (js/Promise.
                  (fn [resolve reject]
                    (set! (.-onload reader)
                          #(let [buf (js/Uint8Array. (.-result reader))
                                 enc (cond
                                       (and (= (aget buf 0) 0xFE) (= (aget buf 1) 0xFF)) "UTF-16BE"
                                       (and (= (aget buf 0) 0xFF) (= (aget buf 1) 0xFE)) "UTF-16LE"
                                       (and (= (aget buf 0) 0xEF) (= (aget buf 1) 0xBB) (= (aget buf 2) 0xBF)) "UTF-8"
                                       :else "UTF-8")]
                             (resolve enc)))
                    (set! (.-onerror reader) #(reject (.-error reader)))
                    (.readAsArrayBuffer reader slice)))]
    (await-> promise
             (then [enc] (println "Detected" enc) enc)
             (catch [err] 
               (js/console.error "While detecting encoding: " err)))))

(defn normalize-mime
  "Takes a File object and returns a new File with a MIME type based on its extension.
  If the extension is not mapped, returns the original file."
  [^js file detected-encoding]
  (let [name (.-name file)
        ext  (str/lower-case (last (str/split name #"\.")))
        mime (get extension->mime ext)
        enc  (when 
               (and 
                 detected-encoding 
                 (text-extensions ext))
               (str "; charset=" detected-encoding))]
    (if (or mime enc)
      (js/File. #js [file] name #js {:type (str mime enc)}) file)))

(defn file->mime [^js file detected-encoding]
  (.-type ^js (normalize-mime file detected-encoding)))

(defn digest-file [^js file]
  (js/Promise. 
    (fn [resolve reject]
      (doto (js/FileReader.)
        (-> .-onload 
            (set! 
              (fn [e]
                (await-> 
                  (js/crypto.subtle.digest "SHA-1" (.-result (.-target e)))
                  (then [buf]
                        (->> (js/Uint8Array. buf)
                             (map (fn [b]
                                    (.padStart (.toString b 16) 2 "0")))
                             (apply str)
                             resolve))
                  (catch [err] (reject err))))))
        (.readAsArrayBuffer file)))))

(defn upload-file [file]
  (let [form-data (js/FormData.)]
    (await-> 
      (detect-encoding file)
      (then [detected-encoding] 
            
            (let [normalized (normalize-mime file detected-encoding)]
              
              (.append form-data "file" normalized)
              
              (await->
                (auth/get-id-token)
                (then [token]  
                      (fetch 
                        (-> (fns/get-https-function-url "upload")
                            (url/url)
                            (update :query assoc "mime" (.-type normalized)))
                        {:method "POST"
                         :body form-data
                         :headers 
                         { :Authorization (str "Bearer " token) }}))))))))

(defn asset-link [Path]
  (-> "asset"
      (fns/get-https-function-url)
      (url/url)
      (assoc :query {:p Path})
      str))

(defn asset-preview [{:strs [Mime Path] :as asset}]
  (cond 
    (nil? Mime)
    [:code "error"]
    
    (str/starts-with? Mime "application/vnd.recordare.musicxml+xml")
    [:iframe 
     {:style {:height 300
              :display :block
              :width "100%"
              :flex "1 1 auto"}
      :src (str "/musicxml.html?url="
                (js/encodeURIComponent (asset-link Path)))}]
    
    (str/starts-with? Mime "image/")
    [:img
     {:style {:max-width 200
              :max-height 200}
      :src (asset-link Path)}]
    
    (str/starts-with? Mime "audio/")
    [:audio {:controls true
             :preload :none
             :style 
             {:width "100%"}}
     [:source {:src (asset-link Path)
               :style {:width "90%"}}]
     [:code.deemph Mime]]
    
    :else [:p "unknown" Mime (mime->extension Mime)]))
